//@ts-nocheck
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Asd {
  /** @format uuid */
  phoneCallId?: string
  to?: string | null
  hasChild?: boolean
  /** @format date-time */
  createdOn?: string
  /** @format int32 */
  answeredRingsCount?: number
  users?: string[] | null
  phoneNumber?: string | null
}

export interface BaseRingsModel {
  /** @format uuid */
  ringId?: string | null
  userName?: string | null
  /** @format uuid */
  userId?: string | null
  /** @format uuid */
  teamId?: string | null
  isAnswered?: boolean | null
  /** @format uuid */
  phoneCallId?: string | null
  /** @format date-time */
  createdOn?: string
  teamName?: string | null
}

export interface BaseUserModel {
  /** @format uuid */
  id?: string
  fullName?: string | null
  domainName?: string | null
  imageUrl?: string | null
  position?: string | null
  team?: string | null
}

export interface CallDetailOpportunityBase {
  /** @format uuid */
  id?: string
  name?: string | null
  status?: string | null
  /** @format int32 */
  statusValue?: number | null
  /** @format date-time */
  createdOn?: string
  opportunityId?: string | null
  owner?: BaseUserModel
}

export interface CallcenterMembersTransferredCallsDetail {
  /** @format uuid */
  id?: string | null
  fullName?: string | null
  /** @format int32 */
  answeredCallCount?: number
}

export interface CombinatoryItems {
  id?: string | null
  /** @format int32 */
  happyCallResultOption: number
  invoiceResultValue?: string | null
}

export interface ContactIdNameWithAccountIdName {
  /** @format uuid */
  id?: string
  name?: string | null
  /** @format uuid */
  accountId?: string | null
  accountName?: string | null
}

export interface CountType {
  name?: string | null
  /** @format int32 */
  count?: number
}

export interface CustomerInformationParam {
  /** @format uuid */
  customerId?: string | null
  name?: string | null
  mobileNumber?: string[] | null
  companyName?: string | null
  phoneNumber?: string[] | null
  /** @format int32 */
  sourceValue?: number | null
  source?: string | null
  /** @format int32 */
  callNumberType?: number | null
}

export interface CustomerPhoneCallListResponse {
  customerName?: string | null
  /** @format uuid */
  customerId?: string | null
  /** @format uuid */
  phoneCallId?: string
  phoneNumber?: string | null
  /** @format date-time */
  createdOn?: string
  user?: BaseUserModel
  status?: string | null
  /** @format int32 */
  durationInSec?: number | null
  voiceUrl?: string | null
  isPhoneCallAnswered?: boolean
}

export interface CustomersHappyCallListRequest {
  /** @format date-time */
  fromDate: string
  /** @format date-time */
  toDate: string
  /** @format int32 */
  order?: number | null
  openInvoicesCount?: number[] | null
  assigneeIds?: string[] | null
  isUnknownAssignee?: boolean | null
  search?: string | null
  /** @format int32 */
  pageSize?: number
  /** @format int32 */
  currentPage?: number
}

export interface FindOtherInvoiceHappyCallsRequest {
  /** @format date-time */
  fromDate: string
  /** @format date-time */
  toDate: string
  /** @minLength 1 */
  invoiceId: string
  /** @format int32 */
  order?: number | null
  status?: number[] | null
  openInvoicesCount?: number[] | null
  assigneeIds?: string[] | null
  search?: string | null
}

export interface FindOtherPurchaseHappyCallsRequest {
  /** @format date-time */
  fromDate: string
  /** @format date-time */
  toDate: string
  purchaseId?: string | null
  search?: string | null
  /** @format int32 */
  order?: number | null
  status?: number[] | null
  openInvoicesCount?: number[] | null
  assigneeIds?: string[] | null
}

export interface GetAdvanceFilterProducts {
  new_brand_terms?: string[] | null
  new_size_terms?: string[] | null
  new_state_terms?: string[] | null
  new_standard_terms?: string[] | null
  new_thickness_terms?: string[] | null
  new_stock_terms?: string[] | null
}

export interface GetAdvanceFilterProductsList {
  items?: GetAdvanceFilterProducts[] | null
}

export interface GetAllTermsOptionsResponse {
  termName?: string | null
  items?: GetTermsOptionsResponse[] | null
}

export interface GetAwaitingReviewHappyCallsResponse {
  id?: string | null
  happyCallId?: string | null
  /** @format date-time */
  createdOn?: string | null
  title?: string | null
  customerName?: string | null
  customerId?: string | null
  phoneNumbers?: PhoneBookResponse[] | null
  requesterName?: string | null
  requesterImageUrl?: string | null
  lastHappyCallResult?: string | null
}

export interface GetAwaitingReviewHappyCallsResponsePaginationResponse {
  items?: GetAwaitingReviewHappyCallsResponse[] | null
  /** @format int32 */
  totalCount?: number | null
  /** @format int32 */
  currentPage?: number | null
  /** @format int32 */
  pageSize?: number | null
}

export interface GetChangeRequestHappyCallResponse {
  entityName?: string | null
  /** @format uuid */
  entityId?: string | null
  customerName?: string | null
  createdBy?: string | null
  /** @format uuid */
  happyCallId?: string
  /** @format date-time */
  createdOn?: string | null
  /** @format date-time */
  modifiedOn?: string | null
  relatedId?: string | null
  result?: string | null
  /** @format int32 */
  resultValue?: number | null
  subject?: string | null
  /** @format uuid */
  customerId?: string | null
  /** @format int32 */
  customerType?: number | null
  phoneBooks?: PhoneBookResponse[] | null
}

export interface GetChangeRequestHappyCallResponsePaginationResponse {
  items?: GetChangeRequestHappyCallResponse[] | null
  /** @format int32 */
  totalCount?: number | null
  /** @format int32 */
  currentPage?: number | null
  /** @format int32 */
  pageSize?: number | null
}

export interface GetClientDataResponse {
  accountName?: string | null
  contactName?: string | null
  leadName?: string | null
  leadSource?: LabelValue
  /** @format uuid */
  accountId?: string | null
  /** @format uuid */
  contactId?: string
  /** @format uuid */
  leadId?: string
  preName?: LabelValue
  /** @format int32 */
  invoiceCount?: number
  isVIP?: boolean
  vipBroker?: string | null
  companyName?: string | null
  isNewCustomer?: boolean
  phoneNumbers?: string[] | null
  /** @format int32 */
  quoteCount?: number
  /** @format double */
  accountBalance?: number | null
  /** @format double */
  creditBalance?: number | null
  isPrePaymentRequired?: boolean | null
}

export interface GetDailyCallsReportResponse {
  /** @format int32 */
  callCount?: number
  /** @format int32 */
  callsWithRingCount?: number
  date?: string | null
}

export interface GetDistinctOnProductResponse {
  /** @format uuid */
  productId?: string | null
  productName?: string | null
}

export interface GetDistinctOnTeamsResponse {
  /** @format uuid */
  teamId?: string
  teamName?: string | null
}

export interface GetDistinctOnUserResponse {
  /** @format uuid */
  userId?: string
  name?: string | null
}

export interface GetFollowUpRequestsResponse {
  /** @format uuid */
  entityGuid?: string
  entityId?: string | null
  createdBy?: string | null
  /** @format uuid */
  createdById?: string
  /** @format date-time */
  createdOn?: string | null
  entityType?: string | null
  client?: string | null
  status?: string | null
  phoneNumber?: string[] | null
}

export interface GetHappyCallTypesResponse {
  /** @format uuid */
  value?: string
  name?: string | null
}

export interface GetInvoiceCustomersHappyCallResponse {
  id?: string | null
  invoiceId?: string | null
  /** @format date-time */
  createdOn?: string | null
  customerName?: string | null
  /** @format uuid */
  customerId?: string | null
  /** @format int32 */
  customerType?: number | null
  coordinatorName?: string | null
  description?: string | null
  /** @format int32 */
  descriptionValue?: number | null
  /** @format int32 */
  pendingInvoicesCount?: number
  assigneeName?: string | null
  assigneeImageUrl?: string | null
  assigneeDomain?: string | null
  /** @format uuid */
  assigneeId?: string | null
  /** @format int32 */
  phoneCount?: number | null
  phoneBooks?: PhoneBookResponse[] | null
}

export interface GetInvoiceCustomersHappyCallResponsePaginationResponse {
  items?: GetInvoiceCustomersHappyCallResponse[] | null
  /** @format int32 */
  totalCount?: number | null
  /** @format int32 */
  currentPage?: number | null
  /** @format int32 */
  pageSize?: number | null
}

export interface GetLostCustomersHappyCallsResponse {
  id?: string | null
  /** @format date-time */
  createdOn?: string | null
  customerName?: string | null
  coordinatorName?: string | null
  /** @format int32 */
  customerEtc?: number | null
  /** @format uuid */
  customerId?: string | null
  /** @format uuid */
  opportunityId?: string
  assigneeName?: string | null
  assigneeImageUrl?: string | null
  assigneeDomain?: string | null
  /** @format uuid */
  assigneeId?: string | null
  /** @format int32 */
  phoneCount?: number | null
  phoneBooks?: PhoneBookResponse[] | null
  /** @format int32 */
  pendingInvoicesCount?: number
}

export interface GetLostCustomersHappyCallsResponsePaginationResponse {
  items?: GetLostCustomersHappyCallsResponse[] | null
  /** @format int32 */
  totalCount?: number | null
  /** @format int32 */
  currentPage?: number | null
  /** @format int32 */
  pageSize?: number | null
}

export interface GetMainPhoneCallsWithTotalRingsResponse {
  /** @format date-time */
  createdOn?: string
  /** @format int32 */
  count?: number
  /** @format uuid */
  phoneCallId?: string
}

export interface GetSafCallsResponse {
  /** @format int32 */
  answeredCallsCount?: number
  /** @format int32 */
  missCallsCount?: number
  /** @format date-time */
  dateTime?: string
}

export interface GetSafCallsWithUniqueNumbersResponse {
  /** @format date-time */
  date?: string
  /** @format int32 */
  count?: number
}

export interface GetTeamInputCallsReportResponse {
  /** @format int32 */
  totalCallsCount?: number
  /** @format double */
  totalCallsProgress?: number | null
  /** @format int32 */
  answeredCallsCount?: number
  /** @format double */
  answeredCallsProgress?: number | null
  /** @format int32 */
  notAnsweredCallsCount?: number
  /** @format double */
  notAnsweredCallsProgress?: number | null
  details?: TeamInputCallsHourlyReport[] | null
}

export interface GetTeamMembersInputCallsReportResponse {
  fullName?: string | null
  imageUrl?: string | null
  position?: string | null
  /** @format double */
  answeredCallsPercentageRatio?: number | null
  /** @format double */
  averageCallDuration?: number | null
  /** @format int32 */
  totalCallsCount?: number
  /** @format int32 */
  missCallsCount?: number
  /** @format int32 */
  deadLockCount?: number | null
  /** @format int32 */
  leadCount?: number
  /** @format int32 */
  unregisteredCallCount?: number
  /** @format int32 */
  burnedOutCallsCount?: number
}

export interface GetTermsOptionsOfTermIdRequest {
  terms: string[]
  /** @format uuid */
  productTypeId: string
}

export interface GetTermsOptionsOfTermIdRequestNew {
  /** @minLength 1 */
  term: string
  /** @format uuid */
  productTypeId: string
  /** @format uuid */
  new_stock_terms?: string | null
  /** @format uuid */
  new_size_terms?: string | null
  /** @format uuid */
  new_brand_terms?: string | null
  /** @format uuid */
  new_standard_terms?: string | null
  /** @format uuid */
  new_state_terms?: string | null
  /** @format uuid */
  new_thickness_terms?: string | null
}

export interface GetTermsOptionsResponse {
  /** @format uuid */
  id?: string
  name?: string | null
}

export interface GetTotalPhoneCallsCountGroupByTeamsResponse {
  teamName?: string | null
  /** @format uuid */
  teamId?: string
  /** @format int32 */
  totalCallCount?: number
  /** @format int32 */
  missCallCount?: number
  /** @format int32 */
  burnoutCallCount?: number
}

export interface GetTransferredCallsByCallcenterResponse {
  callCenterMembers?: CallcenterMembersTransferredCallsDetail[] | null
  otherMembers?: OtherMembersTransferredCallsDetail[] | null
}

export interface HappyCallAssigneeUsersResponse {
  id?: string | null
  name?: string | null
}

export type HappyCallListResponsePaginationCustomResponse = object

export interface HappyCallReportResponse {
  /** @format double */
  percentageProgress?: number | null
  /** @format int32 */
  currentCount?: number
}

export interface IdName {
  /** @format uuid */
  id?: string
  name?: string | null
}

export interface IdNameResponse {
  id?: string | null
  name?: string | null
}

export interface Int32LabelValuePercentage {
  label?: string | null
  /** @format int32 */
  value?: number
  /** @format double */
  percentage?: number | null
}

export interface InvoicesHappyCallStatisticResponse {
  overview?: Overview
  statusCounts?: StatusCount[] | null
}

export interface LabelValue {
  label?: string | null
  /** @format int32 */
  value?: number
}

export interface LeadIdNameCompanyName {
  /** @format uuid */
  id?: string
  name?: string | null
  companyName?: string | null
}

export interface OnlineQuoteResponse {
  /** @format uuid */
  opportunityId?: string
  id?: string | null
  customerName?: string | null
  customerId?: string | null
  /** @format int32 */
  customerType?: number
  phoneNumber?: string | null
  type?: string | null
  /** @format int32 */
  status?: number | null
  /** @format date-time */
  createdOn?: string
  fileUrl?: string | null
  description?: string | null
}

export interface OnlineQuoteResponsePaginationResponse {
  items?: OnlineQuoteResponse[] | null
  /** @format int32 */
  totalCount?: number | null
  /** @format int32 */
  currentPage?: number | null
  /** @format int32 */
  pageSize?: number | null
}

export interface OpportunityHappyCallReportResponse {
  /** @format int32 */
  allHappyCallCount?: number | null
  /** @format int32 */
  opportunityHappyCallCount?: number | null
  groupedOpportunitiesByCallResult?: CountType[] | null
}

export interface OptionSetResponse {
  label?: string | null
  /** @format int32 */
  value?: number | null
}

export interface OtherMembersTransferredCallsDetail {
  fullName?: string | null
  /** @format int32 */
  directTransferredCallsCount?: number
  /** @format int32 */
  answeredTransfersCount?: number
}

export interface OutgoingPhoneCallsDetailsResponse {
  /** @format uuid */
  phoneCallId?: string
  /** @format date-time */
  createdOn?: string | null
  customerName?: string | null
  customerAccountName?: string | null
  /** @format uuid */
  customerId?: string | null
  phoneNumber?: string | null
  /** @format int32 */
  callsCount?: number
  /** @format int32 */
  invoicesCount?: number
  type?: string | null
  isAnswered?: boolean
  /** @format int32 */
  duration?: number | null
  voiceUrl?: string | null
  rings?: RelatedRingsResponse[] | null
  status?: string | null
  /** @format int32 */
  typeValue?: number | null
  hasOpportunity?: boolean
  opportunity?: CallDetailOpportunityBase
  isVip?: boolean
  isNewCustomer?: boolean
  isAccount?: boolean
  isContact?: boolean
  customerInfo?: CustomerInformationParam
}

export interface Overview {
  /** @format int32 */
  count?: number
  /** @format double */
  percentageProgress?: number | null
}

export interface PhoneBookResponse {
  isDefault?: boolean | null
  phoneNumber?: string | null
  name?: string | null
  type?: string | null
}

export interface PhoneCallDetailsResponse {
  /** @format uuid */
  phoneCallId?: string
  /** @format date-time */
  createdOn?: string | null
  customerName?: string | null
  customerAccountName?: string | null
  /** @format uuid */
  customerId?: string | null
  phoneNumber?: string | null
  /** @format int32 */
  callsCount?: number
  /** @format int32 */
  invoicesCount?: number
  type?: string | null
  isAnswered?: boolean
  /** @format int32 */
  duration?: number | null
  voiceUrl?: string | null
  rings?: RelatedRingsResponse[] | null
  status?: string | null
}

export interface PhoneCallListResponse {
  customerName?: string | null
  /** @format uuid */
  phoneCallId?: string
  phoneNumber?: string | null
  /** @format date-time */
  createdOn?: string
  user?: BaseUserModel
  type?: string | null
  status?: string | null
  /** @format int32 */
  durationInSec?: number | null
  voiceUrl?: string | null
  hasAnyRing?: boolean
  /** @format int32 */
  typeValue?: number | null
  isPhoneCallAnswered?: boolean
  rings?: BaseRingsModel[] | null
}

export interface PhoneCallListResponsePaginationResponse {
  items?: PhoneCallListResponse[] | null
  /** @format int32 */
  totalCount?: number | null
  /** @format int32 */
  currentPage?: number | null
  /** @format int32 */
  pageSize?: number | null
}

export interface PhoneCallNotificationRequestDto {
  /** @minLength 1 */
  state: string
}

export interface PhoneNumberRequestDto {
  phoneNumber?: string | null
}

export interface PurchaseHappyCallResponse {
  id?: string | null
  /** @format uuid */
  purchaseId?: string
  /** @format date-time */
  createdOn?: string | null
  /** @format uuid */
  accountId?: string | null
  /** @format uuid */
  contactId?: string | null
  customerName?: string | null
  /** @format int32 */
  purchaseCount?: number
  assigneeName?: string | null
  assigneeImageUrl?: string | null
  assigneeDomain?: string | null
  /** @format uuid */
  assigneeId?: string | null
  /** @format int32 */
  phoneCount?: number | null
  phoneBooks?: PhoneBookResponse[] | null
}

export interface PurchaseHappyCallResponsePaginationResponse {
  items?: PurchaseHappyCallResponse[] | null
  /** @format int32 */
  totalCount?: number | null
  /** @format int32 */
  currentPage?: number | null
  /** @format int32 */
  pageSize?: number | null
}

export interface RelatedRingsResponse {
  /** @format date-time */
  createdOn?: string
  /** @format int32 */
  duration?: number | null
  user?: BaseUserModel
  isCallPickup?: boolean
  /** @format int32 */
  transferType?: number | null
  isAnswered?: boolean
  opportunityProductTypes?: StringLabelValue[] | null
}

export interface Requester {
  /** @format uuid */
  id?: string
  fullName?: string | null
  domainName?: string | null
  team?: string | null
  /** @format uuid */
  teamId?: string | null
  position?: string | null
  extension?: string | null
  mobilePhoneNumber?: string | null
  email?: string | null
}

export interface SalesPersonProductResponse {
  /** @format uuid */
  id?: string
  name?: string | null
  /** @format double */
  price?: number | null
  /** @format date-time */
  lastUpdatedPriceDate?: string | null
  unit?: string | null
  /** @format uuid */
  unitId?: string | null
  size?: string | null
  standard?: string | null
  brand?: string | null
  stock?: string | null
  state?: string | null
  /** @format double */
  unitWeight?: number | null
  /** @format int32 */
  invoiceCount?: number | null
}

export interface SearchInClientsResponse {
  accounts?: IdName[] | null
  contacts?: ContactIdNameWithAccountIdName[] | null
  leads?: LeadIdNameCompanyName[] | null
}

export interface StatesAndCities {
  state?: string | null
  city?: string | null
}

export interface StatusCount {
  title?: string | null
  /** @format int32 */
  count?: number
}

export interface StringLabelValue {
  label?: string | null
  value?: string | null
}

export interface StringStringKeyValuePair {
  key?: string | null
  value?: string | null
}

export interface StringValueCount {
  value?: string | null
  /** @format int32 */
  count?: number
}

export interface SubmitAwaitingReviewHappyCallRequest {
  /** @minLength 1 */
  happyCallId: string
  /** @format int32 */
  happyCallResultOption: number
  unhappyResultValueResultValue?: string | null
  /** @minLength 1 */
  description: string
}

export interface SubmitHappyCallResponse {
  /** @format uuid */
  happyCallId?: string
}

export interface SubmitInvoiceHappyCallRequest {
  invoiceIds: string[]
  /** @minLength 1 */
  callDate: string
  /** @minLength 1 */
  description: string
  invoiceResultValues?: string[] | null
  /** @minLength 1 */
  callReceiverName: string
  /** @format int32 */
  happyCallResultOption: number
  /** @format int32 */
  combinatoryDissatisfactionOption: number
  users?: CombinatoryItems[] | null
  products?: CombinatoryItems[] | null
  teams?: CombinatoryItems[] | null
}

export interface SubmitOpportunityHappyCallRequest {
  opportunityIds?: string[] | null
  /** @minLength 1 */
  callDate: string
  callReceiverName?: string | null
  description?: string | null
  opportunityResultValues?: string[] | null
  /** @format int32 */
  happyCallResultOption: number
}

export interface SubmitPurchaseHappyCallRequest {
  purchaseIds: string[]
  /** @minLength 1 */
  callDate: string
  description?: string | null
  callReceiverName?: string | null
  purchaseResultValues?: string[] | null
  /** @format int32 */
  happyCallResultOption: number
}

export interface TeamInputCallsHourlyReport {
  hour?: string | null
  /** @format int32 */
  totalCallsCount?: number
  /** @format int32 */
  missCallsCount?: number
}

export interface UpdateHappyCallAssigneeToCurrentUserRequest {
  customerId?: string | null
}

export interface UpdateOnlineQuoteStatusRequest {
  /** @format uuid */
  id: string
  /** @format int32 */
  value: number
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private secure?: boolean
  private format?: ResponseType

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || '/callcenter' })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method)

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      const propertyContent: any[] = property instanceof Array ? property : [property]

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem))
      }

      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>)
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    })
  }
}

/**
 * @title Ahanonline.App
 * @version 1.0
 * @baseUrl /callcenter
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  excel = {
    /**
     * No description
     *
     * @tags Excel
     * @name GetCallCenterReportList
     * @request GET:/Excel/GetCallCenterReport
     * @secure
     */
    getCallCenterReportList: (
      query?: {
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/Excel/GetCallCenterReport`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),
  }
  fix = {
    /**
     * No description
     *
     * @tags Fix
     * @name FixAnsweredCallsWithNoAnsweredRingsList
     * @request GET:/Fix/FixAnsweredCallsWithNoAnsweredRings
     * @secure
     */
    fixAnsweredCallsWithNoAnsweredRingsList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/Fix/FixAnsweredCallsWithNoAnsweredRings`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fix
     * @name GetCallsList
     * @request GET:/Fix/GetCalls
     * @secure
     */
    getCallsList: (params: RequestParams = {}) =>
      this.request<Asd[], any>({
        path: `/Fix/GetCalls`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fix
     * @name GetMainPhoneCallsWithTotalRingsList
     * @request GET:/Fix/GetMainPhoneCallsWithTotalRings
     * @secure
     */
    getMainPhoneCallsWithTotalRingsList: (params: RequestParams = {}) =>
      this.request<GetMainPhoneCallsWithTotalRingsResponse[], any>({
        path: `/Fix/GetMainPhoneCallsWithTotalRings`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fix
     * @name GetSafCallsList
     * @request GET:/Fix/GetSafCalls
     * @secure
     */
    getSafCallsList: (params: RequestParams = {}) =>
      this.request<GetSafCallsResponse[], any>({
        path: `/Fix/GetSafCalls`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fix
     * @name GetDeadlockList
     * @request GET:/Fix/GetDeadlock
     * @secure
     */
    getDeadlockList: (params: RequestParams = {}) =>
      this.request<LabelValue[], any>({
        path: `/Fix/GetDeadlock`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fix
     * @name GetSafCallsWithUniqueNumbersList
     * @request GET:/Fix/GetSafCallsWithUniqueNumbers
     * @secure
     */
    getSafCallsWithUniqueNumbersList: (params: RequestParams = {}) =>
      this.request<GetSafCallsWithUniqueNumbersResponse[], any>({
        path: `/Fix/GetSafCallsWithUniqueNumbers`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  happyCall = {
    /**
     * No description
     *
     * @tags HappyCallProcessAwaitingReview
     * @name ProcessAwaitingReviewSubmitAwaitingReviewHappyCallsCreate
     * @request POST:/HappyCall/Process/AwaitingReview/SubmitAwaitingReviewHappyCalls
     * @secure
     */
    processAwaitingReviewSubmitAwaitingReviewHappyCallsCreate: (
      data: SubmitAwaitingReviewHappyCallRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/HappyCall/Process/AwaitingReview/SubmitAwaitingReviewHappyCalls`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessAwaitingReview
     * @name ProcessAwaitingReviewGetAwaitingReviewHappyCallsList
     * @request GET:/HappyCall/Process/AwaitingReview/GetAwaitingReviewHappyCalls
     * @secure
     */
    processAwaitingReviewGetAwaitingReviewHappyCallsList: (
      query?: {
        /** @format int32 */
        Order?: number
        OpenInvoicesCount?: number[]
        AssigneeIds?: string[]
        Search?: string
        /** @format int32 */
        PageSize?: number
        /** @format int32 */
        CurrentPage?: number
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetAwaitingReviewHappyCallsResponsePaginationResponse, any>({
        path: `/HappyCall/Process/AwaitingReview/GetAwaitingReviewHappyCalls`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessAwaitingReview
     * @name ProcessAwaitingReviewGetOtherCustomerAwaitingReviewHappyCallsList
     * @request GET:/HappyCall/Process/AwaitingReview/GetOtherCustomerAwaitingReviewHappyCalls
     * @secure
     */
    processAwaitingReviewGetOtherCustomerAwaitingReviewHappyCallsList: (
      query?: {
        CustomerId?: string
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetAwaitingReviewHappyCallsResponse[], any>({
        path: `/HappyCall/Process/AwaitingReview/GetOtherCustomerAwaitingReviewHappyCalls`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessInvoice
     * @name ProcessInvoiceGetHappyCallInvoicesByCustomerIdList
     * @request GET:/HappyCall/Process/Invoice/GetHappyCallInvoicesByCustomerId
     * @secure
     */
    processInvoiceGetHappyCallInvoicesByCustomerIdList: (
      query?: {
        CustomerId?: string
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<IdNameResponse[], any>({
        path: `/HappyCall/Process/Invoice/GetHappyCallInvoicesByCustomerId`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessInvoice
     * @name ProcessInvoiceGetInvoiceResultTypesList
     * @request GET:/HappyCall/Process/Invoice/GetInvoiceResultTypes
     * @secure
     */
    processInvoiceGetInvoiceResultTypesList: (params: RequestParams = {}) =>
      this.request<OptionSetResponse[], any>({
        path: `/HappyCall/Process/Invoice/GetInvoiceResultTypes`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessInvoice
     * @name ProcessInvoiceGetInvoiceHappyCallDissatisfactionOptionsList
     * @request GET:/HappyCall/Process/Invoice/GetInvoiceHappyCallDissatisfactionOptions
     * @secure
     */
    processInvoiceGetInvoiceHappyCallDissatisfactionOptionsList: (params: RequestParams = {}) =>
      this.request<GetHappyCallTypesResponse[], any>({
        path: `/HappyCall/Process/Invoice/GetInvoiceHappyCallDissatisfactionOptions`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessInvoice
     * @name ProcessInvoiceGetDistinctOnTeamsList
     * @request GET:/HappyCall/Process/Invoice/GetDistinctOnTeams
     * @secure
     */
    processInvoiceGetDistinctOnTeamsList: (
      query?: {
        InvoiceIds?: string[]
      },
      params: RequestParams = {}
    ) =>
      this.request<GetDistinctOnTeamsResponse[], any>({
        path: `/HappyCall/Process/Invoice/GetDistinctOnTeams`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessInvoice
     * @name ProcessInvoiceGetDistinctOnPersonList
     * @request GET:/HappyCall/Process/Invoice/GetDistinctOnPerson
     * @secure
     */
    processInvoiceGetDistinctOnPersonList: (
      query?: {
        InvoiceIds?: string[]
      },
      params: RequestParams = {}
    ) =>
      this.request<GetDistinctOnUserResponse[], any>({
        path: `/HappyCall/Process/Invoice/GetDistinctOnPerson`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessInvoice
     * @name ProcessInvoiceGetDistinctOnProductList
     * @request GET:/HappyCall/Process/Invoice/GetDistinctOnProduct
     * @secure
     */
    processInvoiceGetDistinctOnProductList: (
      query?: {
        InvoiceIds?: string[]
      },
      params: RequestParams = {}
    ) =>
      this.request<GetDistinctOnProductResponse[], any>({
        path: `/HappyCall/Process/Invoice/GetDistinctOnProduct`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessInvoice
     * @name ProcessInvoiceGetDistinctItemsList
     * @request GET:/HappyCall/Process/Invoice/GetDistinctItems
     * @secure
     */
    processInvoiceGetDistinctItemsList: (params: RequestParams = {}) =>
      this.request<OptionSetResponse[], any>({
        path: `/HappyCall/Process/Invoice/GetDistinctItems`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessInvoice
     * @name ProcessInvoiceSubmitInvoiceHappyCallCreate
     * @request POST:/HappyCall/Process/Invoice/SubmitInvoiceHappyCall
     * @secure
     */
    processInvoiceSubmitInvoiceHappyCallCreate: (data: SubmitInvoiceHappyCallRequest, params: RequestParams = {}) =>
      this.request<SubmitHappyCallResponse[], any>({
        path: `/HappyCall/Process/Invoice/SubmitInvoiceHappyCall`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessOpportunity
     * @name ProcessOpportunityGetHappyCallOpportunitiesByCustomerIdList
     * @request GET:/HappyCall/Process/Opportunity/GetHappyCallOpportunitiesByCustomerId
     * @secure
     */
    processOpportunityGetHappyCallOpportunitiesByCustomerIdList: (
      query?: {
        CustomerId?: string
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<IdNameResponse[], any>({
        path: `/HappyCall/Process/Opportunity/GetHappyCallOpportunitiesByCustomerId`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessOpportunity
     * @name ProcessOpportunityGetHappyOpportunityResultTypesList
     * @request GET:/HappyCall/Process/Opportunity/GetHappyOpportunityResultTypes
     * @secure
     */
    processOpportunityGetHappyOpportunityResultTypesList: (params: RequestParams = {}) =>
      this.request<OptionSetResponse[], any>({
        path: `/HappyCall/Process/Opportunity/GetHappyOpportunityResultTypes`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessOpportunity
     * @name ProcessOpportunityGetOpportunityHappyCallDissatisfactionOptionsList
     * @request GET:/HappyCall/Process/Opportunity/GetOpportunityHappyCallDissatisfactionOptions
     * @secure
     */
    processOpportunityGetOpportunityHappyCallDissatisfactionOptionsList: (params: RequestParams = {}) =>
      this.request<GetHappyCallTypesResponse[], any>({
        path: `/HappyCall/Process/Opportunity/GetOpportunityHappyCallDissatisfactionOptions`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessOpportunity
     * @name ProcessOpportunitySubmitOpportunityHappyCallCreate
     * @request POST:/HappyCall/Process/Opportunity/SubmitOpportunityHappyCall
     * @secure
     */
    processOpportunitySubmitOpportunityHappyCallCreate: (
      data: SubmitOpportunityHappyCallRequest,
      query?: {
        requester?: Requester
      },
      params: RequestParams = {}
    ) =>
      this.request<SubmitHappyCallResponse[], any>({
        path: `/HappyCall/Process/Opportunity/SubmitOpportunityHappyCall`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessPurchase
     * @name ProcessPurchaseGetHappyCallPurchasesByCustomerIdList
     * @request GET:/HappyCall/Process/Purchase/GetHappyCallPurchasesByCustomerId
     * @secure
     */
    processPurchaseGetHappyCallPurchasesByCustomerIdList: (
      query?: {
        CustomerId?: string
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<PurchaseHappyCallResponse[], any>({
        path: `/HappyCall/Process/Purchase/GetHappyCallPurchasesByCustomerId`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessPurchase
     * @name ProcessPurchaseGetPurchaseResultTypesList
     * @request GET:/HappyCall/Process/Purchase/GetPurchaseResultTypes
     * @secure
     */
    processPurchaseGetPurchaseResultTypesList: (params: RequestParams = {}) =>
      this.request<GetHappyCallTypesResponse[], any>({
        path: `/HappyCall/Process/Purchase/GetPurchaseResultTypes`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessPurchase
     * @name ProcessPurchaseSubmitPurchaseHappyCallCreate
     * @request POST:/HappyCall/Process/Purchase/SubmitPurchaseHappyCall
     * @secure
     */
    processPurchaseSubmitPurchaseHappyCallCreate: (data: SubmitPurchaseHappyCallRequest, params: RequestParams = {}) =>
      this.request<SubmitHappyCallResponse[], any>({
        path: `/HappyCall/Process/Purchase/SubmitPurchaseHappyCall`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  happyCallReport = {
    /**
     * No description
     *
     * @tags HappyCallReport
     * @name GetTotalHappyCallsCountList
     * @request GET:/HappyCallReport/GetTotalHappyCallsCount
     * @secure
     */
    getTotalHappyCallsCountList: (
      query?: {
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<HappyCallReportResponse, any>({
        path: `/HappyCallReport/GetTotalHappyCallsCount`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallReport
     * @name GetInvoiceHappyCallsCountList
     * @request GET:/HappyCallReport/GetInvoiceHappyCallsCount
     * @secure
     */
    getInvoiceHappyCallsCountList: (
      query?: {
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<HappyCallReportResponse, any>({
        path: `/HappyCallReport/GetInvoiceHappyCallsCount`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallReport
     * @name GetOpportunityHappyCallCountList
     * @request GET:/HappyCallReport/GetOpportunityHappyCallCount
     * @secure
     */
    getOpportunityHappyCallCountList: (
      query?: {
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<HappyCallReportResponse, any>({
        path: `/HappyCallReport/GetOpportunityHappyCallCount`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallReport
     * @name GetPurchaseHappyCallsCountList
     * @request GET:/HappyCallReport/GetPurchaseHappyCallsCount
     * @secure
     */
    getPurchaseHappyCallsCountList: (
      query?: {
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<HappyCallReportResponse, any>({
        path: `/HappyCallReport/GetPurchaseHappyCallsCount`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallReport
     * @name GetSubmittedHappyCallsList
     * @request GET:/HappyCallReport/GetSubmittedHappyCalls
     * @secure
     */
    getSubmittedHappyCallsList: (
      query?: {
        /** @format date-time */
        FromDate?: string
        /** @format date-time */
        ToDate?: string
        Search?: string
        /** @format int32 */
        PageSize?: number
        /** @format int32 */
        CurrentPage?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<HappyCallListResponsePaginationCustomResponse, any>({
        path: `/HappyCallReport/GetSubmittedHappyCalls`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallReport
     * @name GetOpportunityHappyCallStatisticsList
     * @request GET:/HappyCallReport/GetOpportunityHappyCallStatistics
     * @secure
     */
    getOpportunityHappyCallStatisticsList: (
      query?: {
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<OpportunityHappyCallReportResponse, any>({
        path: `/HappyCallReport/GetOpportunityHappyCallStatistics`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallReport
     * @name GetInvoicesHappyCallStatisticsCreate
     * @request POST:/HappyCallReport/GetInvoicesHappyCallStatistics
     * @secure
     */
    getInvoicesHappyCallStatisticsCreate: (
      query?: {
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<InvoicesHappyCallStatisticResponse, any>({
        path: `/HappyCallReport/GetInvoicesHappyCallStatistics`,
        method: 'POST',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  happyCalls = {
    /**
     * No description
     *
     * @tags HappyCalls
     * @name GetOpportunityCustomersCreate
     * @request POST:/HappyCalls/GetOpportunityCustomers
     * @secure
     */
    getOpportunityCustomersCreate: (data: CustomersHappyCallListRequest, params: RequestParams = {}) =>
      this.request<GetLostCustomersHappyCallsResponsePaginationResponse, any>({
        path: `/HappyCalls/GetOpportunityCustomers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCalls
     * @name FindOtherOpportunityHappyCallsList
     * @request GET:/HappyCalls/FindOtherOpportunityHappyCalls
     * @secure
     */
    findOtherOpportunityHappyCallsList: (
      query?: {
        OpportunityId?: string
        /** @format int32 */
        Order?: number
        Status?: number[]
        OpenInvoicesCount?: number[]
        AssigneeIds?: string[]
        Search?: string
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetLostCustomersHappyCallsResponse[], any>({
        path: `/HappyCalls/FindOtherOpportunityHappyCalls`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCalls
     * @name GetInvoiceCustomersCreate
     * @request POST:/HappyCalls/GetInvoiceCustomers
     * @secure
     */
    getInvoiceCustomersCreate: (data: CustomersHappyCallListRequest, params: RequestParams = {}) =>
      this.request<GetInvoiceCustomersHappyCallResponsePaginationResponse, any>({
        path: `/HappyCalls/GetInvoiceCustomers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCalls
     * @name FindOtherInvoiceHappyCallsCreate
     * @request POST:/HappyCalls/FindOtherInvoiceHappyCalls
     * @secure
     */
    findOtherInvoiceHappyCallsCreate: (data: FindOtherInvoiceHappyCallsRequest, params: RequestParams = {}) =>
      this.request<GetInvoiceCustomersHappyCallResponse[], any>({
        path: `/HappyCalls/FindOtherInvoiceHappyCalls`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCalls
     * @name GetPurchaseHappyCallsCreate
     * @request POST:/HappyCalls/GetPurchaseHappyCalls
     * @secure
     */
    getPurchaseHappyCallsCreate: (data: CustomersHappyCallListRequest, params: RequestParams = {}) =>
      this.request<PurchaseHappyCallResponsePaginationResponse, any>({
        path: `/HappyCalls/GetPurchaseHappyCalls`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCalls
     * @name FindOtherPurchaseHappyCallsCreate
     * @request POST:/HappyCalls/FindOtherPurchaseHappyCalls
     * @secure
     */
    findOtherPurchaseHappyCallsCreate: (data: FindOtherPurchaseHappyCallsRequest, params: RequestParams = {}) =>
      this.request<PurchaseHappyCallResponse[], any>({
        path: `/HappyCalls/FindOtherPurchaseHappyCalls`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCalls
     * @name GetHappyCallAssigneeUsersList
     * @request GET:/HappyCalls/GetHappyCallAssigneeUsers
     * @secure
     */
    getHappyCallAssigneeUsersList: (params: RequestParams = {}) =>
      this.request<HappyCallAssigneeUsersResponse[], any>({
        path: `/HappyCalls/GetHappyCallAssigneeUsers`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCalls
     * @name UpdateHappyCallAssigneeToCurrentUserCreate
     * @request POST:/HappyCalls/UpdateHappyCallAssigneeToCurrentUser
     * @secure
     */
    updateHappyCallAssigneeToCurrentUserCreate: (
      data: UpdateHappyCallAssigneeToCurrentUserRequest,
      query?: {
        requester?: Requester
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/HappyCalls/UpdateHappyCallAssigneeToCurrentUser`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCalls
     * @name GetPendingHappyCallsList
     * @request GET:/HappyCalls/GetPendingHappyCalls
     * @secure
     */
    getPendingHappyCallsList: (
      query?: {
        /** @format int32 */
        PageSize?: number
        /** @format int32 */
        CurrentPage?: number
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetChangeRequestHappyCallResponsePaginationResponse, any>({
        path: `/HappyCalls/GetPendingHappyCalls`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCalls
     * @name GetHappyCallResultOptionsList
     * @request GET:/HappyCalls/GetHappyCallResultOptions
     * @secure
     */
    getHappyCallResultOptionsList: (params: RequestParams = {}) =>
      this.request<LabelValue[], any>({
        path: `/HappyCalls/GetHappyCallResultOptions`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  notifications = {
    /**
     * No description
     *
     * @tags Notifications
     * @name SendPhonecallNotificationCreate
     * @request POST:/Notifications/SendPhonecallNotification
     * @secure
     */
    sendPhonecallNotificationCreate: (
      data: PhoneCallNotificationRequestDto,
      query?: {
        requester?: Requester
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/Notifications/SendPhonecallNotification`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  onDemands = {
    /**
     * No description
     *
     * @tags OnDemands
     * @name RelateRingsList
     * @request GET:/OnDemands/RelateRings
     * @secure
     */
    relateRingsList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/OnDemands/RelateRings`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnDemands
     * @name RelatePhoneCallsParentList
     * @request GET:/OnDemands/RelatePhoneCallsParent
     * @secure
     */
    relatePhoneCallsParentList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/OnDemands/RelatePhoneCallsParent`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  }
  onlineQuotes = {
    /**
     * No description
     *
     * @tags OnlineQuotes
     * @name OnlineQuotesList
     * @request GET:/OnlineQuotes
     * @secure
     */
    onlineQuotesList: (
      query?: {
        /** @format int32 */
        Status?: number
        Search?: string
        /** @format int32 */
        PageSize?: number
        /** @format int32 */
        CurrentPage?: number
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<OnlineQuoteResponsePaginationResponse, any>({
        path: `/OnlineQuotes`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineQuotes
     * @name UpdateStatusCreate
     * @request POST:/OnlineQuotes/UpdateStatus
     * @secure
     */
    updateStatusCreate: (
      data: UpdateOnlineQuoteStatusRequest,
      query?: {
        requester?: Requester
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/OnlineQuotes/UpdateStatus`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineQuotes
     * @name GetStatusesList
     * @request GET:/OnlineQuotes/GetStatuses
     * @secure
     */
    getStatusesList: (params: RequestParams = {}) =>
      this.request<LabelValue[], any>({
        path: `/OnlineQuotes/GetStatuses`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  outgoingPhoneCalls = {
    /**
     * No description
     *
     * @tags OutgoingPhoneCalls
     * @name OutgoingPhoneCallsList
     * @request GET:/OutgoingPhoneCalls
     * @secure
     */
    outgoingPhoneCallsList: (
      query?: {
        Statuses?: string[]
        Types?: number[]
        Teams?: string[]
        Search?: string
        /** @format int32 */
        PageSize?: number
        /** @format int32 */
        CurrentPage?: number
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<PhoneCallListResponsePaginationResponse, any>({
        path: `/OutgoingPhoneCalls`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OutgoingPhoneCalls
     * @name OutgoingPhoneCallsDetail
     * @request GET:/OutgoingPhoneCalls/{phoneCallId}
     * @secure
     */
    outgoingPhoneCallsDetail: (phoneCallId: string, params: RequestParams = {}) =>
      this.request<OutgoingPhoneCallsDetailsResponse, any>({
        path: `/OutgoingPhoneCalls/${phoneCallId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OutgoingPhoneCalls
     * @name GetPhonecallTypesList
     * @request GET:/OutgoingPhoneCalls/GetPhonecallTypes
     * @secure
     */
    getPhonecallTypesList: (params: RequestParams = {}) =>
      this.request<LabelValue[], any>({
        path: `/OutgoingPhoneCalls/GetPhonecallTypes`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OutgoingPhoneCalls
     * @name GetLeadSourceList
     * @request GET:/OutgoingPhoneCalls/GetLeadSource
     * @secure
     */
    getLeadSourceList: (params: RequestParams = {}) =>
      this.request<LabelValue[], any>({
        path: `/OutgoingPhoneCalls/GetLeadSource`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  getCustomerPhoneCallsList = {
    /**
     * No description
     *
     * @tags PhoneCalls
     * @name GetCustomerPhoneCallsListList
     * @summary لیست تماس های ورودی یک شخص
     * @request GET:/GetCustomerPhoneCallsList
     * @secure
     */
    getCustomerPhoneCallsListList: (
      query?: {
        /** @format uuid */
        CustomerId?: string
        Search?: string
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<CustomerPhoneCallListResponse[], any>({
        path: `/GetCustomerPhoneCallsList`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  phoneCalls = {
    /**
     * No description
     *
     * @tags PhoneCalls
     * @name PhoneCallsList
     * @summary لیست مدیریت تماس های ورودی
     * @request GET:/PhoneCalls
     * @secure
     */
    phoneCallsList: (
      query?: {
        Statuses?: string[]
        Types?: number[]
        Teams?: string[]
        Search?: string
        /** @format int32 */
        PageSize?: number
        /** @format int32 */
        CurrentPage?: number
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<PhoneCallListResponsePaginationResponse, any>({
        path: `/PhoneCalls`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PhoneCalls
     * @name PhoneCallsDetail
     * @summary گرفتن جزئیات تماس
     * @request GET:/PhoneCalls/{phoneCallId}
     * @secure
     */
    phoneCallsDetail: (phoneCallId: string, params: RequestParams = {}) =>
      this.request<PhoneCallDetailsResponse, any>({
        path: `/PhoneCalls/${phoneCallId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PhoneCalls
     * @name GetRelatedRingsDetail
     * @summary گرفتن زنگ های مربوط به تماس
     * @request GET:/PhoneCalls/GetRelatedRings/{phoneCallId}
     * @secure
     */
    getRelatedRingsDetail: (phoneCallId: string, params: RequestParams = {}) =>
      this.request<RelatedRingsResponse[], any>({
        path: `/PhoneCalls/GetRelatedRings/${phoneCallId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  reports = {
    /**
     * No description
     *
     * @tags Reports
     * @name GetTotalCallcenterCallsCountList
     * @summary تعداد تمام تماس های ورودی کالسنتر
     * @request GET:/Reports/GetTotalCallcenterCallsCount
     * @secure
     */
    getTotalCallcenterCallsCountList: (
      query?: {
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<number, any>({
        path: `/Reports/GetTotalCallcenterCallsCount`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name GetTotalCallsCountList
     * @summary تعداد تمام تماس های ورودی
     * @request GET:/Reports/GetTotalCallsCount
     * @secure
     */
    getTotalCallsCountList: (
      query?: {
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<number, any>({
        path: `/Reports/GetTotalCallsCount`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name GetTotalCallcenterMissCallsCountList
     * @summary تعداد تمام تماس های از دست رفته ورودی کالسنتر
     * @request GET:/Reports/GetTotalCallcenterMissCallsCount
     * @secure
     */
    getTotalCallcenterMissCallsCountList: (
      query?: {
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<number, any>({
        path: `/Reports/GetTotalCallcenterMissCallsCount`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name GetTotalMissCallsCountList
     * @summary تعداد تمام تماس های از دست رفته ورودی
     * @request GET:/Reports/GetTotalMissCallsCount
     * @secure
     */
    getTotalMissCallsCountList: (
      query?: {
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<number, any>({
        path: `/Reports/GetTotalMissCallsCount`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name GetUniqueCallsCountList
     * @summary تعداد تمام تماس های های ورودی یکتا
     * @request GET:/Reports/GetUniqueCallsCount
     * @secure
     */
    getUniqueCallsCountList: (
      query?: {
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<number, any>({
        path: `/Reports/GetUniqueCallsCount`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name GetCallcenterUniqueCallsCountList
     * @summary تعداد تمام تماس های های ورودی یکتا کالسنتر
     * @request GET:/Reports/GetCallcenterUniqueCallsCount
     * @secure
     */
    getCallcenterUniqueCallsCountList: (
      query?: {
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<number, any>({
        path: `/Reports/GetCallcenterUniqueCallsCount`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name GetNewCustomersCountList
     * @summary تعداد تمام مشتری های جدید ثبت شده
     * @request GET:/Reports/GetNewCustomersCount
     * @secure
     */
    getNewCustomersCountList: (
      query?: {
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<number, any>({
        path: `/Reports/GetNewCustomersCount`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name GetCallcenterNewCustomersCountList
     * @summary تعداد تمام مشتری های جدید ثبت شده توسط کالسنتر
     * @request GET:/Reports/GetCallcenterNewCustomersCount
     * @secure
     */
    getCallcenterNewCustomersCountList: (
      query?: {
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<number, any>({
        path: `/Reports/GetCallcenterNewCustomersCount`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name GetLeadSourceStatisticsList
     * @summary نحوه آشنایی مشتریان
     * @request GET:/Reports/GetLeadSourceStatistics
     * @secure
     */
    getLeadSourceStatisticsList: (
      query?: {
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<StringValueCount[], any>({
        path: `/Reports/GetLeadSourceStatistics`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name GetCallsPercentByTypeList
     * @summary دسته بندی تماس ها براساس نوع مشتری
     * @request GET:/Reports/GetCallsPercentByType
     * @secure
     */
    getCallsPercentByTypeList: (
      query?: {
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<Int32LabelValuePercentage[], any>({
        path: `/Reports/GetCallsPercentByType`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name GetDailyCallsReportList
     * @summary گزارش روزانه تماس ها
     * @request GET:/Reports/GetDailyCallsReport
     * @secure
     */
    getDailyCallsReportList: (
      query?: {
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetDailyCallsReportResponse[], any>({
        path: `/Reports/GetDailyCallsReport`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name GetTransferredCallsByCallcenterList
     * @summary تماس های انتقال یافته از کال سنتر به کارشناسان فروش
     * @request GET:/Reports/GetTransferredCallsByCallcenter
     * @secure
     */
    getTransferredCallsByCallcenterList: (
      query?: {
        /** @format uuid */
        TeamId?: string
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetTransferredCallsByCallcenterResponse, any>({
        path: `/Reports/GetTransferredCallsByCallcenter`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name GetIncomingCallsGroupByTeamsReportList
     * @summary تعداد تماس تیم ها
     * @request GET:/Reports/GetIncomingCallsGroupByTeamsReport
     * @secure
     */
    getIncomingCallsGroupByTeamsReportList: (
      query?: {
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetTotalPhoneCallsCountGroupByTeamsResponse[], any>({
        path: `/Reports/GetIncomingCallsGroupByTeamsReport`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name GetTeamInputCallsReportList
     * @summary گزارش تماس های ورودی گروه
     * @request GET:/Reports/GetTeamInputCallsReport
     * @secure
     */
    getTeamInputCallsReportList: (
      query?: {
        /** @format uuid */
        TeamId?: string
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetTeamInputCallsReportResponse, any>({
        path: `/Reports/GetTeamInputCallsReport`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name GetTeamMembersInputCallsReportList
     * @summary گزارش تماس های ورودی گروه به ازای هر نفر
     * @request GET:/Reports/GetTeamMembersInputCallsReport
     * @secure
     */
    getTeamMembersInputCallsReportList: (
      query?: {
        /** @format uuid */
        TeamId?: string
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetTeamMembersInputCallsReportResponse[], any>({
        path: `/Reports/GetTeamMembersInputCallsReport`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  salesPersons = {
    /**
 * No description
 *
 * @tags SalesPersons
 * @name GetProductsCreate
 * @summary دریافت کالا ها
(فرستادن شناسه پروداکت تایپ اجباری است)
 * @request POST:/SalesPersons/GetProducts
 * @secure
 */
    getProductsCreate: (
      data: GetAdvanceFilterProductsList,
      query?: {
        /** @format uuid */
        productTypeId?: string
        search?: string
        /** @format int32 */
        orderBy?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<SalesPersonProductResponse[], any>({
        path: `/SalesPersons/GetProducts`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
 * No description
 *
 * @tags SalesPersons
 * @name GetProductTypesList
 * @summary دریافت پروداکت تایپ ها
(در صورتی که سرچ پر باشد بر اساس سرچ جست و جو میکردد در غیر این صورت پروداکت تایپ های اصلی و فرعی هر کاربر بر میگردد)
 * @request GET:/SalesPersons/GetProductTypes
 * @secure
 */
    getProductTypesList: (
      query?: {
        Search?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<IdName[], any>({
        path: `/SalesPersons/GetProductTypes`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPersons
     * @name GetCitiesList
     * @summary دریافت شهر های کشور
     * @request GET:/SalesPersons/GetCities
     * @secure
     */
    getCitiesList: (
      query?: {
        Search?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<StatesAndCities[], any>({
        path: `/SalesPersons/GetCities`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPersons
     * @name SearchInClientsList
     * @summary جست و جو در اکانت - کانتکت - لید
     * @request GET:/SalesPersons/SearchInClients
     * @secure
     */
    searchInClientsList: (
      query?: {
        Search?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<SearchInClientsResponse, any>({
        path: `/SalesPersons/SearchInClients`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPersons
     * @name GetClientDataDetail
     * @summary گرفتن اطلاعات مورد نیاز اکانت - کانتکت یا لید در فرم کارشناس فروش
     * @request GET:/SalesPersons/GetClientData/{clientId}
     * @secure
     */
    getClientDataDetail: (clientId: string, params: RequestParams = {}) =>
      this.request<GetClientDataResponse, any>({
        path: `/SalesPersons/GetClientData/${clientId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
 * No description
 *
 * @tags SalesPersons
 * @name GetTermOfProductTypeIdList
 * @summary دریافت ترم های مربوط به یک پروداکت تایپ
ترم هایی مانند سایز و برند
 * @request GET:/SalesPersons/GetTermOfProductTypeId
 * @secure
 */
    getTermOfProductTypeIdList: (
      query: {
        ProductTypeId: string
      },
      params: RequestParams = {}
    ) =>
      this.request<StringLabelValue[], any>({
        path: `/SalesPersons/GetTermOfProductTypeId`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
 * No description
 *
 * @tags SalesPersons
 * @name OptionsSalesPersons
 * @summary دریافت مقادیر مختلف برای ترم هایی تعیین شده
مثلا مقادیر های 25 و 30 برای ترم سایز
 * @request OPTIONS:/SalesPersons/GetTermsOptions
 * @secure
 */
    optionsSalesPersons: (data: GetTermsOptionsOfTermIdRequest, params: RequestParams = {}) =>
      this.request<GetAllTermsOptionsResponse[], any>({
        path: `/SalesPersons/GetTermsOptions`,
        method: 'OPTIONS',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPersons
     * @name OptionsSalesPersons2
     * @request OPTIONS:/SalesPersons/GetTermsOptionsNewVersion
     * @originalName optionsSalesPersons
     * @duplicate
     * @secure
     */
    optionsSalesPersons2: (data: GetTermsOptionsOfTermIdRequestNew, params: RequestParams = {}) =>
      this.request<GetTermsOptionsResponse[], any>({
        path: `/SalesPersons/GetTermsOptionsNewVersion`,
        method: 'OPTIONS',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPersons
     * @name GetFollowUpRequestsList
     * @request GET:/SalesPersons/GetFollowUpRequests
     * @secure
     */
    getFollowUpRequestsList: (
      query?: {
        /** @format uuid */
        ClientId?: string
        /** @format int32 */
        Order?: number
        Search?: string
        IsCreatedByMe?: boolean
        Entity?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetFollowUpRequestsResponse[], any>({
        path: `/SalesPersons/GetFollowUpRequests`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPersons
     * @name GetFollowUpRequestsEntitiesList
     * @request GET:/SalesPersons/GetFollowUpRequestsEntities
     * @secure
     */
    getFollowUpRequestsEntitiesList: (params: RequestParams = {}) =>
      this.request<StringStringKeyValuePair[], any>({
        path: `/SalesPersons/GetFollowUpRequestsEntities`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  sms = {
    /**
     * No description
     *
     * @tags Sms
     * @name SendPriceListCreate
     * @request POST:/Sms/SendPriceList
     * @secure
     */
    sendPriceListCreate: (
      data: PhoneNumberRequestDto,
      query?: {
        requester?: Requester
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/Sms/SendPriceList`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sms
     * @name SendNeginInfoCreate
     * @request POST:/Sms/SendNeginInfo
     * @secure
     */
    sendNeginInfoCreate: (
      data: PhoneNumberRequestDto,
      query?: {
        requester?: Requester
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/Sms/SendNeginInfo`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sms
     * @name SendOxinInfoCreate
     * @request POST:/Sms/SendOxinInfo
     * @secure
     */
    sendOxinInfoCreate: (
      data: PhoneNumberRequestDto,
      query?: {
        requester?: Requester
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/Sms/SendOxinInfo`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sms
     * @name SendSellerInfoCreate
     * @request POST:/Sms/SendSellerInfo
     * @secure
     */
    sendSellerInfoCreate: (
      data: PhoneNumberRequestDto,
      query?: {
        requester?: Requester
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/Sms/SendSellerInfo`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  teams = {
    /**
     * No description
     *
     * @tags Teams
     * @name GetCallcenterTeamsList
     * @request GET:/Teams/GetCallcenterTeams
     * @secure
     */
    getCallcenterTeamsList: (params: RequestParams = {}) =>
      this.request<IdName[], any>({
        path: `/Teams/GetCallcenterTeams`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
}
